module.exports = __webpack_public_path__ + "static/ingenious_artillerist_mtg_clb-e9bc19ef63d575df043e44007136e32e.webp";